import { fetchCoachCategories } from '../../../redux/features/coach/actions/authAction';
import { getFormData, updateFormData } from '../../../utils/pip';
import { useDispatch, useSelector } from 'react-redux';
import { step2Schema } from '../../../utils/schema';
import ErrorMessage from '../../form/ErrorMessage';
import StepsDots from '../../form/StepsDots';
import React, { useEffect } from 'react';
import { Formik } from 'formik';
import Loader from '../../loader';

const CoachSignUpStep2Modal = ({ stepBack, onClose, setSignupStep, isLoad }) => {
    const dispatch = useDispatch();
    const savedData = getFormData().step2;
    const { categoryList } = useSelector((state) => state.coach.auth);

    const handleStep2 = (values) => {
        updateFormData("step2", values);
        setSignupStep();
    };

    if (isLoad) {
        return <Loader />
    }
    return (
        <div
            className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div class="modal-content">
                    <div class="modal-header border-0 p-0 pb-2">
                        <button
                            type="button"
                            class="btn-close ct_close_position_right12"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body pe-0">
                        <section class="ct_signup_main py-3">
                            <div class="container-fluid">
                                <div class="row align-items-center">
                                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                                        <div class="ct_signup_left_img">
                                            <img
                                                src="../assets/img/coach_step_1_img.png"
                                                alt=""
                                                style={{ objectFit: " cover" }}
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto pe-0">
                                        <div class="ct_signup_right_content px-5 ct_custom_scroll">
                                            <div
                                                className="ct_back_top_btn"
                                                onClick={stepBack}
                                            >
                                                <i class="fa-solid fa-arrow-left"></i>
                                            </div>
                                            <div class="ct_signup_logo ct_mb_30">
                                                <img src="../assets/img/Nuvio_logo.png" alt="" />
                                            </div>
                                            <div class="mt-0 text-center">
                                                <h2 class="ct_fs_32  mb-2 ct_darkblue_text">
                                                    Define Your Coaching Path
                                                </h2>
                                                <p
                                                    class="mb-0 ct_darkblue_text mx-auto"
                                                    style={{ maxWidth: "523px" }}
                                                >
                                                    Help us understand your coaching strengths so we can
                                                    tailor the experience to your style and clients.
                                                </p>
                                            </div>
                                            <Formik
                                                initialValues={savedData}
                                                validationSchema={step2Schema}
                                                onSubmit={(values, actions) => {
                                                    handleStep2(values);
                                                }}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    setFieldValue,
                                                }) => (
                                                    <form onSubmit={handleSubmit} class="mt-5">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        Coaching Category
                                                                    </label>
                                                                    <div className="d-flex flex-column gap-2 position-relative">
                                                                        <select
                                                                            id="category_id"
                                                                            name="category_id"
                                                                            value={values?.category_id}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            class="form-control ct_input"
                                                                        >
                                                                            <option value={""}>Select Coaching Category</option>;
                                                                            {categoryList?.map((item, ind) => {
                                                                                return (
                                                                                    <option value={item?.category_id}>
                                                                                        {item?.category_name}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                                    </div>
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName={"category_id"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        {" "}
                                                                        Years of Experience{" "}
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="Years of Experience "
                                                                        id="year_of_experience"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.year_of_experience}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="year_of_experience"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        Coaching Format
                                                                    </label>
                                                                    <div className="d-flex flex-column gap-2 position-relative">
                                                                        <select
                                                                            name="format"
                                                                            id="format"
                                                                            value={values?.format}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            class="form-control ct_input"
                                                                        >
                                                                            <option value={""}>Select Coaching Format</option>;
                                                                            {[
                                                                                { label: "1:1", val: "1:1" },
                                                                                { label: "Group", val: "GROUP" },
                                                                                { label: "Both", val: "BOTH" },
                                                                            ]?.map((item, ind) => {
                                                                                return (
                                                                                    <option value={item?.val}>{item?.label}</option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                                    </div>
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName={"format"}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-2">
                                                            <a class="ct_yellow_btn w-75 mx-auto" onClick={handleSubmit}>
                                                                Continue{" "}
                                                            </a>
                                                        </div>

                                                        <StepsDots activeStep={2} />
                                                    </form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CoachSignUpStep2Modal;